module.exports = __webpack_public_path__ + "img/Builder.e191b51d.svg";